import React from 'react';
import { motion } from 'framer-motion';
import { Plug, MessagesSquare, Banknote } from 'lucide-react';
export function HowItWorks() {
  const steps = [{
    number: '01',
    icon: <Plug className="w-5 h-5" data-id="element-210" />,
    title: 'Plug in once',
    desc: 'One REST API or pre-built connectors for SAP, Oracle, and Workday. Your team is live in days, not quarters.'
  }, {
    number: '02',
    icon: <MessagesSquare className="w-5 h-5" data-id="element-211" />,
    title: 'Your customers transact',
    desc: 'Customers settle accounts via *120*Masube#, SMS, or WhatsApp. No app to download, no data plan needed.'
  }, {
    number: '03',
    icon: <Banknote className="w-5 h-5" data-id="element-212" />,
    title: 'Funds land same-day',
    desc: 'PayShap settles to your bank account within 60 seconds. Reconciliation files dropped daily via SFTP or webhook.'
  }];
  return <section id="how-it-works" className="py-24 bg-ink-2 border-y border-white/5" data-id="element-213">
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-214">
        <div className="max-w-3xl mb-16" data-id="element-215">
          <div className="text-xs font-medium uppercase tracking-[0.2em] text-mint mb-4" data-id="element-216">
            How it works
          </div>
          <h2 className="display text-bone mb-6" style={{
          fontSize: 'clamp(2.25rem, 5vw, 4rem)'
        }} data-id="element-217">
            
            Three steps from{' '}
            <span className="display-italic text-mint" data-id="element-218">contract</span> to cash.
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-6 relative" data-id="element-219">
          {/* Connecting dashed line */}
          <div className="hidden md:block absolute top-16 left-[15%] right-[15%] border-t border-dashed border-white/10 z-0" data-id="element-220"></div>

          {steps.map((step, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.15
        }} className="relative z-10 bg-ink rounded-3xl p-8 border border-white/5" data-id="element-221">
            
              <div className="flex items-start justify-between mb-8" data-id="element-222">
                <div className="w-12 h-12 rounded-2xl bg-mint text-ink flex items-center justify-center" data-id="element-223">
                  {step.icon}
                </div>
                <div className="mono text-sm text-muted" data-id="element-224">{step.number}</div>
              </div>
              <h3 className="text-2xl font-semibold text-bone mb-3 tracking-tight" data-id="element-225">
                {step.title}
              </h3>
              <p className="text-base text-bone-dim leading-relaxed" data-id="element-226">
                {step.desc}
              </p>
            </motion.div>)}
        </div>

        {/* Code snippet */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mt-12 bg-ink rounded-3xl border border-white/10 overflow-hidden max-w-3xl mx-auto" data-id="element-227">
          
          <div className="flex items-center justify-between px-5 py-3 border-b border-white/5 bg-ink-2" data-id="element-228">
            <div className="flex items-center gap-2" data-id="element-229">
              <div className="w-2.5 h-2.5 rounded-full bg-ink-4" data-id="element-230"></div>
              <div className="w-2.5 h-2.5 rounded-full bg-ink-4" data-id="element-231"></div>
              <div className="w-2.5 h-2.5 rounded-full bg-mint" data-id="element-232"></div>
            </div>
            <div className="mono text-xs text-muted" data-id="element-233">
              POST /v1/accounts/notify
            </div>
          </div>
          <pre className="mono text-sm text-bone-dim p-6 overflow-x-auto leading-relaxed" data-id="element-234">
            <code data-id="element-235">
              <span className="text-muted" data-id="element-236">
                {'// 1. Push a new account balance to Masube'}
              </span>
              {'\n'}
              <span className="text-mint" data-id="element-237">curl</span> -X POST
              https://api.masube.co.za/v1/accounts/notify \{'\n'}
              {'  '}-H{' '}
              <span className="text-mint" data-id="element-238">
                "Authorization: Bearer $MASUBE_KEY"
              </span>{' '}
              \{'\n'}
              {'  '}-d <span className="text-mint" data-id="element-239">'{'{'}</span>
              {'\n'}
              {'    '}
              <span className="text-bone" data-id="element-240">"customer_msisdn"</span>:{' '}
              <span className="text-mint" data-id="element-241">"+27821234567"</span>,{'\n'}
              {'    '}
              <span className="text-bone" data-id="element-242">"account_ref"</span>:{' '}
              <span className="text-mint" data-id="element-243">"EDG-4421"</span>,{'\n'}
              {'    '}
              <span className="text-bone" data-id="element-244">"outstanding_zar"</span>:{' '}
              <span className="text-mint" data-id="element-245">487.50</span>,{'\n'}
              {'    '}
              <span className="text-bone" data-id="element-246">"due_at"</span>:{' '}
              <span className="text-mint" data-id="element-247">"2026-06-15"</span>
              {'\n'}
              {'  '}
              <span className="text-mint" data-id="element-248">{'}'}</span>'
            </code>
          </pre>
        </motion.div>
      </div>
    </section>;
}